export enum SortableThDirection {
  Asc = "asc",
  Desc = "desc",
  None = "none",
}
